<div class="contact-cards-slider">
  <app-slider [gap]="0" [padding]="true">
    <ng-content></ng-content>
  </app-slider>
</div>
